"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProcedureOrphanSteps = void 0;
var path_measurers_1 = require("../path-walkers/path-measurers");
var procedure_to_nodemap_1 = require("./procedure-to-nodemap");
function getProcedureOrphanSteps(steps, stepsBlockedAt) {
    if (stepsBlockedAt == null) {
        return new Set();
    }
    var nodeMap = procedure_to_nodemap_1.convertProcedureToNodeMap(steps)[0];
    var _a = path_measurers_1.getFartherEndingPath("start", nodeMap), visitedNodes = _a[1];
    return path_measurers_1.getOrphanNodes(nodeMap, visitedNodes);
}
exports.getProcedureOrphanSteps = getProcedureOrphanSteps;
